import { EVENT_TYPES } from './MessageTypes';

/**
 * Iframe事件分发器
 * 负责分发各种自定义事件
 */
export class IframeEventDispatcher {
  /**
   * 分发iframe就绪事件
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {string} messageType - 消息类型
   */
  dispatchIframeReady(iframe, messageType) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.IFRAME_READY, {
        detail: { iframe, messageType },
      })
    );
  }

  /**
   * 分发聊天登录成功事件
   * @param {Object} data - 事件数据
   */
  dispatchChatLoginSuccess(data) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.CHAT_LOGIN_SUCCESS, {
        detail: {
          userId: data.userId,
          conversationId: data.conversationId,
          timestamp: Date.now(),
        },
      })
    );
  }

  /**
   * 分发聊天登录失败事件
   * @param {string} error - 错误信息
   */
  dispatchChatLoginError(error) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.CHAT_LOGIN_ERROR, {
        detail: {
          error,
          timestamp: Date.now(),
        },
      })
    );
  }

  /**
   * 分发聊天注销成功事件
   * @param {string} reason - 注销原因
   */
  dispatchChatLogoutSuccess(reason) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.CHAT_LOGOUT_SUCCESS, {
        detail: {
          reason,
          timestamp: Date.now(),
        },
      })
    );
  }

  /**
   * 分发聊天注销失败事件
   * @param {string} error - 错误信息
   * @param {string} reason - 注销原因
   */
  dispatchChatLogoutError(error, reason) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.CHAT_LOGOUT_ERROR, {
        detail: {
          error,
          reason,
          timestamp: Date.now(),
        },
      })
    );
  }

  /**
   * 分发会话切换成功事件
   * @param {string} conversationId - 会话ID
   * @param {string} message - 消息
   */
  dispatchConversationSwitched(conversationId, message) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.CONVERSATION_SWITCHED, {
        detail: {
          conversationId,
          message,
        },
      })
    );
  }

  /**
   * 分发会话切换失败事件
   * @param {string} conversationId - 会话ID
   * @param {string} error - 错误信息
   * @param {string} message - 消息
   * @param {string} errorType - 错误类型
   */
  dispatchConversationSwitchError(conversationId, error, message, errorType) {
    window.dispatchEvent(
      new CustomEvent(EVENT_TYPES.CONVERSATION_SWITCH_ERROR, {
        detail: {
          conversationId,
          error,
          message,
          errorType,
        },
      })
    );
  }
}
